module.exports = __webpack_public_path__ + "static/img/101.3ba76c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/101.jpeg
// module id = 2zTT
// module chunks = 1